export default "__VITE_ASSET__DwMCFb3d__"